<template>
<!-- eslint-disable max-len -->
<list-page
  name="Article"
  use="_id"
  :display="display"
  display-html
  page-prefix="/blade/articles"
  :fetch="getArticles"
  :remove="deleteArticle"
  :sort-options="sortOptions"
  :sort-functions="sortFunctions"
  :default-sort="defaultSort"
></list-page>
</template>

<script>
import { mapActions } from 'vuex';

import ListPage from '../../ui/pages/ListPage';

export default {
  components: {
    ListPage
  },
  data() {
    return {
      sortOptions: [
        'Last Updated',
        'Author',
      ],
      sortFunctions: [
        this.lastUpdatedSort,
        this.authorSort,
      ],
      defaultSort: 0,
    };
  },
  methods: {
    ...mapActions([
      'getArticles',
      'deleteArticle',
    ]),
    display({ title: articleName, updated, author }) {
      const authorString = author ? ` [${author}]` : '';
      const date = updated && new Date(updated);
      const dateString = date ? ` (edited ${date.toLocaleDateString()} ${date.toLocaleTimeString()})` : '';
      return `${articleName}${authorString}${dateString}`;
    },
    dateSort(a, b, fieldName) {
      const aDate = a[fieldName] && new Date(a[fieldName]);
      const bDate = b[fieldName] && new Date(b[fieldName]);
      if (aDate == null && bDate == null) return 0;
      if (aDate == null) return 1;
      if (bDate == null) return -1;
      return (aDate > bDate) ? -1 : ((aDate < bDate) ? 1 : 0);
    },
    stringSort(a, b, fieldName, preprocess = s => s) {
      const aString = preprocess(a[fieldName] && a[fieldName].toLocaleLowerCase());
      const bString = preprocess(b[fieldName] && b[fieldName].toLocaleLowerCase());
      if (aString == null && bString == null) return 0;
      if (aString == null) return 1;
      if (bString == null) return -1;
      return ((aString < bString)
        ? -1
        : ((aString > bString) ? 1 : 0));
    },
    lastUpdatedSort(a, b) {
      return this.dateSort(a, b, 'updated');
    },
    authorSort(a, b) {
      return this.stringSort(a, b, 'author', s => s && s.replace(/<\/?[^>]+(>|$)/g, ''));
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/blade/pages/ArticlesList.vue